import React from "react";
import BankAccountsTable from "./BankAccountsTable";

const BankAccounts = () => {
  return (
    <div>
      <BankAccountsTable />
    </div>
  );
};

export default BankAccounts;
